import type {
  Artist,
  ArtistListItem,
  ArtistsFromMany,
  ArtistsListSelected,
  ArtistsResponse,
  ArtistType,
} from '../types';

export function mapManyDataToIU(data: ArtistsFromMany): ArtistsResponse {
  return {
    artists: data.artists.map((artist) => ({
      id: artist.id,
      slug: artist.slug,
      name: artist.name,
      portfolio: artist.portfolio_value,
      verified: artist.verified,
      featured: artist.featured,
      countries: artist.countries,
      photo: artist.photo,
      artistType: artist.artist_type,
      artAssetCount: artist.art_assets_count,
      birthDate: artist.date_of_birth,
      deathDate: artist.date_of_death,
    })),
    totalCount: data.total_count,
  };
}

export function mapDataToIU(data: Artist): ArtistType {
  return {
    id: data.id,
    slug: data.slug,
    name: data.name,
    verified: data.verified,
    biography: data.biography,
    socialProfiles: data.social_profiles,
    photo: data.photo,
    photoAttribution: data.photo_attribution,
    institutions: data.institutions,
    styles: data.styles,
    fields: data.medium,
    countries: data.locations,
    dateOfBirth: data.date_of_birth,
    dateOfDeath: data.date_of_death,
  };
}

export function mapSelectedArtistsToListItemUI(data: ArtistsListSelected): ArtistListItem[] {
  return data.map((artist) => ({
    id: artist.id,
    slug: artist.slug,
    name: artist.name,
    photo: artist.photo,
  }));
}
